'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fad';
var iconName = 'mug-saucer';
var width = 576;
var height = 512;
var aliases = ["coffee"];
var unicode = 'f0f4';
var svgPathData = ['M32 480c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L64 512c-17.7 0-32-14.3-32-32z', 'M96 32C78.3 32 64 46.3 64 64l0 224c0 53 43 96 96 96l192 0c53 0 96-43 96-96 70.7 0 128-57.3 128-128S518.7 32 448 32L96 32zM448 96c35.3 0 64 28.7 64 64s-28.7 64-64 64l0-128z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faMugSaucer = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;